import React from 'react'
import { Grid, Row, Col } from 'rsuite'
import { 
  GiftOutline, 
  CheckmarkCircleOutline, 
  StorefrontOutline 
} from 'react-ionicons'
import { useQueryCatalogStats } from '@@partner:graphql/query/catalog/catalogStats.gql'
import StatCard from '@components/common/StatCard/StatCard'

export default function CatalogStats () {
  const { data, loading } = useQueryCatalogStats()

  const totalProducts = data?.catalogStats?.total ?? 0
  const activeProducts = data?.catalogStats?.totalActive ?? 0
  const boughtProducts = data?.catalogStats?.totalBoughtCount ?? 0

  return (
    <Grid fluid style={{ marginTop: 20 }}>
      <Row>
        <Col xs={24} sm={12} md={8}>
          <StatCard
            title="Всего товаров"
            count={totalProducts}
            icon={<GiftOutline color="#fff" height="32px" width="32px" />}
            color="#9c27b0"
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <StatCard
            title="Активные товары"
            count={activeProducts}
            icon={<CheckmarkCircleOutline color="#fff" height="32px" width="32px" />}
            color="#4caf50"
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <StatCard
            title="Куплено за месяц"
            count={boughtProducts}
            icon={<StorefrontOutline color="#fff" height="32px" width="32px" />}
            color="#2196f3"
          />
        </Col>
      </Row>
    </Grid>
  )
}
